import React, { useMemo } from 'react';
import { Row } from 'antd';
import SimpleMDE from 'react-simplemde-editor';
import 'easymde/dist/easymde.min.css';

export interface IFormMarkDownEditor {
	onChange: Function;
	value?: string;
	defaultValue?: string;
	editorType?: string;
}

export const FormMarkDownEditor = ({ onChange, defaultValue, value, editorType }: IFormMarkDownEditor) => {
	const hideIcons = ['fullscreen', 'side-by-side', 'heading', 'image'];

	// This useMemo is required
	// https://github.com/RIP21/react-simplemde-editor#options
	const options = useMemo(() => { 
		return {
			blockStyles: {
				italic: '_',
			},
			placeholder: defaultValue,
			autofocus: true,
			hideIcons: hideIcons,
			showIcons: editorType === 'FULL_EDITOR' ? ['strikethrough', 'heading-1', 'heading-2', 'heading-3', 'horizontal-rule'] : ['strikethrough'],
		};
	},[])
	
	return (
		<div style={{ gridColumn: '1/6' }}>
			<Row style={{ width: '100%' }}>
				<div style={{ width: '100%' }}>
					<SimpleMDE
						onChange={(value) => onChange(value)}
						value={value === defaultValue ? '' : value}
						options={options}
					/>
				</div>
			</Row>
		</div>
	);
};
export default FormMarkDownEditor;
